// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W-eG","label":"styles_label__23-PA"};